import { CardContent } from './shared.style';
import { svgIcons } from '@exploration/icons';
import { headlessPageDataAtom } from '@exploration/ui-utils';
import { BaseCard } from '@midwest/web/card';
import { useAtomValue } from 'jotai';

// --------------------------------------------------------------------------

export const CallCard = ({ className }: { className?: string }) => {
  const pageData = useAtomValue(headlessPageDataAtom);
  const { text, callToAction } = pageData ?? {};
  return (
    <BaseCard className={className} raised={true}>
      <CardContent
        icon={text?.['call-card-icon'] as svgIcons}
        headline={text?.['call-card-title']}
        subHeadline={text?.['call-card-description']}
        buttonType="button"
        text={callToAction?.['call-card-button']?.text}
        link={callToAction?.['call-card-button']?.href}
        showChevron={false}
      />
    </BaseCard>
  );
};
